export class RecurringMeetingModel {
  recurringMeetingSk: string;
  meetingSk: string;
  frequency: number;
  interval: number;
  daysofweek: string;
  dayofmonth: number;
  weekofmonth: string;
  weekdayofmonth: string;
  monthofyear: string;
  endtype: number;
  endafteroccurrences: string;
  endbydate: string;

  constructor(data: any) {
    this.recurringMeetingSk = data?.recurringMeetingSk ?? null;
    this.meetingSk = data?.meetingSk ?? null;
    this.frequency = data?.occurences?.id ?? data?.occurences ?? null;
    this.interval = data?.occurencesCount ?? null;
    this.daysofweek = data?.weekDayChip?.join(',') ?? null; //"1, 2, 3, 4"
    this.dayofmonth = data?.dayCount ?? null;
    this.weekofmonth = data?.weekOrder?.description ?? data?.weekOrder ?? null;
    this.weekdayofmonth = data?.weekDay?.id ? String(data?.weekDay?.id) : null;
    this.monthofyear =
      data?.monthOfYear?.description ?? data?.monthOfYear ?? null;
    this.endtype = data?.repeatUntil?.id ?? data?.repeatUntil ?? null;
    this.endafteroccurrences = data?.repeatUntilCount ?? null;

    const end = data?.endByDate ? new Date(data.endByDate) : null;

    if (end) {
      end.setDate(end.getDate());

      // Backend expects string → send YYYY-MM-DD string
      this.endbydate = end.toISOString();
    } else {
      this.endbydate = null;
    }
  }
}